module.exports = __webpack_public_path__ + "static/img/08.a5bb2be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024112/08.png
// module id = FkiS
// module chunks = 0